'use client';

import { isJapanese } from '@/lib/l18n/function';
import { LotteryPrizeStaging as CommonLotteryPrizeStaging, type LotteryPrizeStagingHandler } from '@monorepo/common';
import type { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

interface LotteryPrizeStagingProps {
  id: number;
  stagingRank: string;
  stagingText: string;
  customRef: MutableRefObject<LotteryPrizeStagingHandler | undefined>;
}

function LotteryPrizeStaging(props: LotteryPrizeStagingProps) {
  const { i18n } = useTranslation();
  const locale = isJapanese(i18n.resolvedLanguage) ? 'ja' : 'en';

  return <CommonLotteryPrizeStaging {...props} locale={locale} />;
}

export default LotteryPrizeStaging;
